import React, {Component} from 'react';
import {PropTypes} from 'prop-types';
import CardWidgetSelectDropdown from '../CardWidgetSelectDropdown';
import CardWidgetInputErrorHOC from "./CardWidgetInputErrorHOC";

class CardWidgetSelectDropdownWithErrors extends Component {
  render() {
    return (
        <CardWidgetSelectDropdown
            onChange={this.props.onChange} options={this.props.options}
            customOptions={this.props.customOptions} fieldLabel={this.props.fieldLabel}
        />
    )
  }
}

CardWidgetSelectDropdownWithErrors.propTypes = {
  onChange: PropTypes.func,
  options: PropTypes.string,
  customOptions: PropTypes.array,
  fieldLabel: PropTypes.string,
  errorMessage: PropTypes.string
};

export default CardWidgetInputErrorHOC(CardWidgetSelectDropdownWithErrors);